<template>

<com-item name="player.win" :size="size" :loading="loading" title="Win Balance" :has-more="data.total > 5" v-on:more="onMoreClick">

	<template v-slot:about>

		<p>Break down of {{ your }} game by game win rates with {{ playername }}.</p>

	</template>

	<template v-slot:stats>

		<div class="weight">

			<div class="weight-visual">

				<app-visualisation-quadrants :selected="segmentValue" :labels="['Fewer plays', 'More plays', playername + ' wins', realname + ' wins']" :data="data.grid" v-on:click="onSegmentClick" />

			</div>

			<div class="weight-list">

				<div class="weight-loading"><i class="fa fa-spinner fa-spin" v-if="isLoadingPlayers" /></div>

				<div class="weight-empty" v-if="!isLoadingPlayers && !data.list.length">No players.</div>

				<template v-if="!isLoadingPlayers">

					<app-game :item="item" v-for="(item, index) in data.list" :key="index" :playsAsSubtext="true">

						<div class="players">
						
							<div class="players-item" :class="{'is-green': item.player > item.self, 'is-red': item.player < item.self}">

								<core-avatar type="player" :item="player" />

								<div class="players-item-value">{{ item.player | round }}<small>%</small></div>

							</div>
						
							<div class="players-item" :class="{'is-green': item.player < item.self, 'is-red': item.player > item.self}">

								<core-avatar type="context" />

								<div class="players-item-value">{{ item.self | round }}<small>%</small></div>

							</div>

						</div>

					</app-game>

				</template>

			</div>

		</div>
		
	</template>

	<template v-slot:buttons>

		<com-toggle :options="thresholdOptions" :value="thresholdValue" v-on:change="onThresholdChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

		realname: function() {

			var name = this.$store.getters['context'].fullname || this.$store.getters['context'].name 
			return name.split(' ')[0]

		},

		playername: function() {

			var name = this.player.name
			return name.split(' ')[0]

		},

		thresholdValue: function() {

			return this.$store.getters['filter/insights/player/wins/threshold'] 

		},

		thresholdOptions: function() {

			var options = []

			options.push({value: 1, text: 'No minimum'})
			options.push({value: 2, text: 'Min. 2 plays'})
			options.push({value: 3, text: 'Min. 3 plays'})
			options.push({value: 4, text: 'Min. 4 plays'})
			options.push({value: 5, text: 'Min. 5 plays'})
			options.push({value: 10, text: 'Min. 10 plays'})
			options.push({value: 25, text: 'Min. 25 plays'})

			return options

		},

		segmentValue: function() {

			return this.$store.getters['filter/insights/player/wins/band'] 

		},

		loading: function() {

			return this.fetching === 'all'

		},

		isLoadingPlayers: function() {

			return this.fetching === 'wins.band' || this.fetching === 'wins.threshold'

		},

		player: function() {

			return this.$store.getters['page/insights/player/player']

		},

		data: function() {

			return this.$store.getters['page/insights/player/wins']

		},

		active: function() {

			return this.data.list.length && !this.loading

		}

	},

	methods: {

		onThresholdChange: function(value) {

			this.$store.commit('filter/insights/player/wins/threshold', value)

		},

		onSegmentClick: function(value) {

			this.$store.commit('filter/insights/player/wins/band', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayerWins'
			})
		
		}

	}

}

</script>

<style scoped>

.players {
	display: grid;
	grid-template-columns: 98px 98px;
	grid-gap: 10px;
	height: 48px;
}

.is-mobile .players {
	grid-template-columns: 54px;
	grid-template-rows: 24px 24px;
	grid-gap: 2px;
	height: auto;
}

.players-item {
	display: grid;
	grid-template-columns: 48px 48px;
	grid-gap: 2px;
	height: 48px;
}

.is-mobile .players-item {
	grid-template-columns: 24px 32px;
	height: 24px;
}

.players-item >>> .avatar {
	width: 48px;
	height: 48px;
}

.is-mobile .players-item >>> .avatar {
	width: 24px;
	height: 24px;
}

.players-item-value {
	text-align: center;
	border-radius: 4px;
	height: 48px;
	line-height: 48px;
	font-size: 16px;
	font-weight: 400;
	color: #fff;
	background-color: #4881bb;
}

.is-mobile .players-item-value {
	height: 24px;
	line-height: 24px;
	font-size: 12px!important;
}

.players-item.is-green .players-item-value {
	background-color: #48bb5e;
}

.players-item.is-red .players-item-value {
	background-color: #bb4848;
}

.players-item-value small {
	font-size: 10px;
	opacity: 0.75;
}

.weight {
	display: grid;
	grid-template-columns: 320px 1fr;
	height: 100%;
}

.weight-list {
	border-left: 1px solid #eee;
}

.is-small-mobile .weight {
	grid-template-columns: 1fr;
	grid-template-rows: 300px auto;
}

.is-small-mobile .weight-list {
	border-left: 0px;
	border-top: 1px solid #eee;
}

.weight-loading {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.weight-loading i {
	font-size: 24px;
	transform-origin: 50% 50%;
	color: #ffc563;
}

.weight-empty {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	font-weight: 400;
	color: #ccc;
}

</style>